export default __webpack_public_path__ + "static/media/hotelx.8c16ce8f.png";